import { ContactHelper, DistributionHelper } from '@/helpers'
import { DEFAULT_DISTRIBUTION_PARTNER_NUMBER } from '@/config/constants'

export const FabHelper = {
  async getContactInfo($t, basket) {
    const distributionPartner = basket?.distributionPartners
      ? DistributionHelper.getDistributionPartnerByBasket(basket)
      : DEFAULT_DISTRIBUTION_PARTNER_NUMBER

    return await ContactHelper.getInfo($t, distributionPartner)
  },
}
